import styled from "styled-components";
import { FieldWrapper } from "./styles";

const StyledInput = styled.input`
  color: inherit;
  -webkit-appearance: none;
  outline: 0;
  width: 80%;
  height: 48px;
  box-sizing: border-box;
  border: ${(props) =>
    props.notValid
      ? "1px solid #e6000f"
      : "1px solid rgba(211, 214, 224, 0.5)"};
  width: ${(props) => (props.width ? props.width + "px" : "100%")};
  font-size: 14px;
  padding: 8px 26px 8px 12px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border-radius: 4px;
`;

const Input = ({
  value,
  onChange,
  width,
  placeholder,
  type,
  errorMessage,
  ...props
}) => {
  return (
    <FieldWrapper>
      <StyledInput
        type={type ? type : "text"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        width={width}
        autoComplete="off"
        {...props}
      />

      {props.notValid && (
        <span className={"field-error-text"}>{errorMessage}</span>
      )}
    </FieldWrapper>
  );
};

export default Input;
